var _toConsumableArray = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
module.exports = function (modules) {
  var installedModules = {};
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function __node_modules_Babel_runtimeCorejs3_coreJs_object_definePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function __node_modules_Babel_runtimeCorejs3_helpers_classCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/createClass.js": function __node_modules_Babel_runtimeCorejs3_helpers_createClassJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), _Object$defineProperty(target, descriptor.key, descriptor);
      }
    }
    module.exports = function (Constructor, protoProps, staticProps) {
      return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
    };
  },
  "./index.js": function _indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "Contract", function () {
      return Contract_Contract;
    }), __webpack_require__.d(__webpack_exports__, "types", function () {
      return types;
    });
    __webpack_require__("core-js/modules/web.dom-collections.iterator");
    var includes_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/includes"),
      includes_default = __webpack_require__.n(includes_),
      get_own_property_names_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/get-own-property-names"),
      get_own_property_names_default = __webpack_require__.n(get_own_property_names_),
      for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
      for_each_default = __webpack_require__.n(for_each_),
      keys_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
      keys_default = __webpack_require__.n(keys_),
      sort_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/sort"),
      sort_default = __webpack_require__.n(sort_),
      map_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/map"),
      map_default = __webpack_require__.n(map_),
      classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
      classCallCheck_default = __webpack_require__.n(classCallCheck),
      createClass = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/createClass.js"),
      createClass_default = __webpack_require__.n(createClass),
      external_lodash_ = __webpack_require__("lodash"),
      external_lodash_default = __webpack_require__.n(external_lodash_),
      external_js_sha256_ = __webpack_require__("js-sha256"),
      logger_ = __webpack_require__("@jutro/logger"),
      from_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/array/from"),
      from_default = __webpack_require__.n(from_),
      filter_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/filter"),
      filter_default = __webpack_require__.n(filter_),
      set_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/set"),
      set_default = __webpack_require__.n(set_),
      find_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/find"),
      find_default = __webpack_require__.n(find_),
      get_prototype_of_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/get-prototype-of"),
      get_prototype_of_default = __webpack_require__.n(get_prototype_of_);
    function getPrototype(obj) {
      return obj.prototype || get_prototype_of_default()(obj);
    }
    var ImplDescriptor_ImplDescriptor = function () {
        function ImplDescriptor(objOrFunc) {
          classCallCheck_default()(this, ImplDescriptor), this.instance = objOrFunc, this.allPrototypes = function (object) {
            var proto = getPrototype(object);
            var protos = [];
            for (; null != proto && proto !== Object.prototype;) protos.push(proto), proto = getPrototype(proto);
            return protos;
          }(objOrFunc);
        }
        return createClass_default()(ImplDescriptor, [{
          key: "findPrototypeMember",
          value: function value(name) {
            var _context;
            var proto = find_default()(_context = this.allPrototypes).call(_context, function (p) {
              return void 0 !== p[name];
            });
            return proto ? proto[name] : void 0;
          }
        }, {
          key: "getMembers",
          value: function value() {
            var _context2, _context3;
            var keys = new set_default.a(filter_default()(_context2 = [].concat(_toConsumableArray(get_own_property_names_default()(this.instance)), _toConsumableArray(map_default()(_context3 = this.allPrototypes).call(_context3, function (p) {
              return get_own_property_names_default()(p);
            })))).call(_context2, function (k) {
              return "prototype" !== k && "constructor" !== k;
            }));
            return from_default()(keys);
          }
        }, {
          key: "getMember",
          value: function value(name) {
            return this.instance[name] || this.findPrototypeMember(name);
          }
        }, {
          key: "hasMember",
          value: function value(name) {
            return void 0 !== this.getMember(name);
          }
        }]), ImplDescriptor;
      }(),
      Contract_Contract = function () {
        function Contract(specification) {
          var _external_lodash_defa,
            _this = this;
          for (var _len = arguments.length, extended = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            extended[_key - 1] = arguments[_key];
          }
          classCallCheck_default()(this, Contract), this.spec = (_external_lodash_defa = external_lodash_default.a).merge.apply(_external_lodash_defa, _toConsumableArray(map_default()(extended).call(extended, function (c) {
            return c.spec;
          })).concat([specification])), this.hashFunc = external_lodash_default.a.memoize(function () {
            var _context;
            var keyTar = sort_default()(_context = keys_default()(_this.spec)).call(_context).join("");
            return Object(external_js_sha256_.sha256)(keyTar);
          });
        }
        return createClass_default()(Contract, [{
          key: "implementedBy",
          value: function value(implementor) {
            var _this2 = this;
            var _context2;
            var descriptor = new ImplDescriptor_ImplDescriptor(implementor);
            var adheres = !0;
            var members = descriptor.getMembers();
            return for_each_default()(_context2 = get_own_property_names_default()(this.spec)).call(_context2, function (specKey) {
              var member = descriptor.getMember(specKey);
              member && typeof member === _this2.spec[specKey] || (logger_.log.warning(includes_default()(members).call(members, specKey) ? "Invalid type for ".concat(specKey, ": '").concat(typeof member, "' is not of type '").concat(_this2.spec[specKey], "'") : "Missing member: " + specKey), adheres = !1);
            }), adheres;
          }
        }, {
          key: "hash",
          value: function value() {
            return this.hashFunc();
          }
        }, {
          key: "toString",
          value: function value() {
            return "contract {".concat(keys_default()(this.spec).join(","), "}");
          }
        }], [{
          key: "specify",
          value: function value(specification) {
            return new Contract(specification);
          }
        }]), Contract;
      }();
    var types = {
      func: "function"
    };
  },
  "@babel/runtime-corejs3/core-js-stable/array/from": function babel_runtimeCorejs3_coreJsStable_array_from(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/array/from");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/filter": function babel_runtimeCorejs3_coreJsStable_instance_filter(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/find": function babel_runtimeCorejs3_coreJsStable_instance_find(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/find");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babel_runtimeCorejs3_coreJsStable_instance_forEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/includes": function babel_runtimeCorejs3_coreJsStable_instance_includes(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/includes");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/map": function babel_runtimeCorejs3_coreJsStable_instance_map(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/map");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/sort": function babel_runtimeCorejs3_coreJsStable_instance_sort(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/sort");
  },
  "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names": function babel_runtimeCorejs3_coreJsStable_object_getOwnPropertyNames(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-names");
  },
  "@babel/runtime-corejs3/core-js-stable/object/get-prototype-of": function babel_runtimeCorejs3_coreJsStable_object_getPrototypeOf(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/get-prototype-of");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babel_runtimeCorejs3_coreJsStable_object_keys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/set": function babel_runtimeCorejs3_coreJsStable_set(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/set");
  },
  "@jutro/logger": function jutro_logger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "core-js-pure/features/object/define-property": function coreJsPure_features_object_defineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  "core-js/modules/web.dom-collections.iterator": function coreJs_modules_webDomCollectionsIterator(module, exports) {
    module.exports = require("core-js/modules/web.dom-collections.iterator");
  },
  "js-sha256": function jsSha256(module, exports) {
    module.exports = require("js-sha256");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  }
});